import { render, staticRenderFns } from "./ButtonProgress.vue?vue&type=template&id=581fec8a"
import script from "./ButtonProgress.vue?vue&type=script&lang=js"
export * from "./ButtonProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports